export const PAGES = {
  NEW_EVENT: "newEvent",
  SELECT_EVENT: "selectEvent",
  CLONE_OPTIONS: "cloneOptions",
  SELECT_CONTENT: "selectContent",
  CONFIRMATION: "confirmation"
};

export const DEFAULT_DAY_GROUPS = [
  {
    id: "uuid-load-in-days",
    name: "Load In Days",
    color: "#E19517",
    days: []
  },
  {
    id: "uuid-show-days",
    name: "Show Days",
    color: "#01C07C",
    days: []
  },
  {
    id: "uuid-load-out-days",
    name: "Load Out Days",
    color: "#D0021B",
    days: []
  },
  {
    id: 0,
    name: "Day Off",
    color: "#ffffff",
    days: []
  }
];

export const NAMESPACE = "CloneEventModal";
